module.exports = __webpack_public_path__ + "static/media/5.cf93cc14.png";